import isUrlWhitelisted from "../../helpers/isUrlWhitelisted";

(function () {
	'use strict';

	angular.module('ResearchKitApplicationModule').factory("urlWhitelistValidator", function () {
		return {
			isWhitelisted: isUrlWhitelisted
		}
	});
})();